import React from 'react';
import { CircularProgress, makeStyles } from '@rentacenter/racstrap';

const useStyles = makeStyles((theme: any) => ({
  loading: {
    width: '100%',
    height: '100%',
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: 99999,
  },
  loadingProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  messageBox: {
    backgroundColor: '#fff',
    borderRadius: theme.typography.pxToRem(8),
    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.15)',
    padding: `${theme.typography.pxToRem(24)} ${theme.typography.pxToRem(32)}`,
    minWidth: theme.typography.pxToRem(320),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.typography.pxToRem(16),
  },
  message: {
    color: '#000',
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(16),
    textAlign: 'center',
    whiteSpace: 'pre-line',
  },
}));

interface LoadingOverlayProps {
  message?: string;
}

export const LoadingOverlay = ({ message }: LoadingOverlayProps = {}) => {
  const classes = useStyles();
  return (
    <div className={classes.loading}>
      <div className={classes.loadingProgress}>
        {message ? (
          <div className={classes.messageBox}>
            <CircularProgress />
            <div className={classes.message}>{message}</div>
          </div>
        ) : (
          <CircularProgress />
        )}
      </div>
    </div>
  );
};
